import '../../monitoring/charts/chart_view.js.coffee'

Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.ColumnGraphChartView extends Monitoring.Views.Charts.ChartView
  template: JST['backbone/templates/customer_visual_mode/charts/column_graph_chart']

  initialize: ({graphData}) ->
    @graphData = graphData

  render: ->
    @$el.html @template
    @

  renderChart: =>
    new Highcharts.Chart(@_highchartsOptions())

  _highchartsOptions: ->
    {
      chart: {
        type: 'column',
        renderTo: @$el.find('.column-graph-chart')[0]
      },
      legend: {
        align: 'right',
        verticalAlign: 'top',
        layout: 'vertical',
        itemMarginTop: 1,
        x: 0,
        y: 20,
        itemStyle: {
          fontSize: '16'
        }
      },
      title: {
        text: null
      },
      exporting: {enabled: false},
      xAxis: {
        type: 'category'
      },
      yAxis: {
        min: 0,
        title: {
          text: null
        }
      },
      tooltip: {
        headerFormat: null
      }
      plotOptions: {
        column: {
          grouping: false,
          cursor: 'pointer',
          events: {
            click: (event) => @trigger('ColumnGraph:click:column', event.point.name)
          }
        }
      }
      series: @graphData.map((serie, i) ->
        {
          name: serie.x,
          data: [{
            name: serie.x,
            y: serie.y
          }]
        }
      )
      isHierarchical: true
      isBarHierarchyNavigation: true
    }
